<div class="layout-container" [ngClass]="containerClass">

    <app-topbar></app-topbar>
    <app-sidebar></app-sidebar>

    <div class="layout-content-wrapper">
        <app-breadcrumb></app-breadcrumb>

        <div class="layout-content flex justify-content-center">
            <router-outlet></router-outlet>
        </div>

        <app-footer></app-footer>
    </div>
    <!-- <app-config></app-config> -->

    <div *ngIf="layoutService.state.staticMenuMobileActive" class="layout-mask"></div>
    <p-confirmDialog width="425" acceptLabel="Potvrdi" rejectLabel="Odustani" appendTo="body"></p-confirmDialog>
</div>
